import React, { Component } from 'react';
import {
  Button, Popover, Position
} from '@blueprintjs/core';
import { observable } from 'mobx';
import 'fullcalendar';
import 'fullcalendar-scheduler';
import 'fullcalendar/dist/fullcalendar.css';
import 'fullcalendar-scheduler/dist/scheduler.css';
import { inject, observer } from 'mobx-react';
import SearchDateRangePicker from 'components/SearchDateRangePicker';
import 'jquery-ui/ui/widgets/draggable';
import moment from 'moment-timezone';
import { formatDateRange } from 'helpers/dateRange';
import { makeJobCardsDraggable } from 'helpers/dispatchDraggable';
import { TIMELINE_MIN_LAYOUT_MINUTES } from 'helpers/timelineLayout';
import Footer from '../../components/Footer';
import Pagination from 'components/Pagination';

@inject('jobStore', 'viewStore') @observer
class UnassignedJob extends Component {

  listRef = React.createRef();

  // Cards are re-created on every render, so (re)attach dragging each time.
  componentDidMount() {
    makeJobCardsDraggable(this.listRef.current);
  }

  componentDidUpdate() {
    makeJobCardsDraggable(this.listRef.current);
  }

  @observable startDate = null;
  @observable endDate = null;

  onTermChange(e) {
    let {
      props: {
        jobStore,
        viewStore: {
          unassignedJobSearch
        }
      }
    } = this;
    this.props.viewStore.unassignedJobSearch = {
      ...unassignedJobSearch,
      term: e.target.value,
      page: 1
    }

    jobStore.loadUnassignedJobs()
  }

  onDateRangeChange(range) {
    let {
      props: {
        jobStore,
        viewStore: {
          unassignedJobSearch
        }
      }
    } = this;
    this.props.viewStore.unassignedJobSearch = {
      ...unassignedJobSearch,
      where: {
        ...unassignedJobSearch.where,
        start_date: { 
          gte: moment(range[0]).startOf('day').unix()
        },
        end_date: { 
          lte: moment(range[1]).endOf('day').unix()
        }
      },
      page: 1,
    }
    this.startDate = range[0];
    this.endDate = range[1];
    jobStore.loadUnassignedJobs()
  }

  // The assignment as the calendar expects it, so a dropped card renders
  // correctly in the moment before the calendar refetches.
  dropData(job) {
    const attrs = job.attributes;
    return {
      ...attrs,
      eventNumber: attrs.event_number || (attrs.job && attrs.job.event_number),
      clientName: attrs.client_name || (attrs.client && attrs.client.name) || '',
      fullAddress: (attrs.location && attrs.location.full_address) || '',
      technicianName: attrs.technician_name || '',
      serviceType: attrs.serviceType || attrs.service_type || {},
      priority: ((attrs.job && attrs.job.priority) || attrs.priority || '').toLowerCase(),
      // Stays on the calendar through the refetch after a drop (the board
      // removes it once the saved job comes back).
      stick: true,
      // Lets the calendar size the dropped card before it refetches (at least
      // the timeline's minimum layout length, so it can't overlap).
      duration: moment.duration(Math.max(
        moment(attrs.end_date).diff(moment(attrs.start_date)),
        TIMELINE_MIN_LAYOUT_MINUTES * 60 * 1000
      )).toISOString(),
    };
  }

  renderDateTime(startDate, endDate) {
    const startDateFormatted = moment(startDate).format("MMM D, YY h:mma");
    const endDateFormatted = moment(endDate).format("MMM D, YY h:mma");
    const combined = moment(startDate).format("MMM D, YY h:mma") + " - " + moment(endDate).format("h:mma");
    const sameStartAndEnd = moment(startDate).format("MM/DD/YYYY") === moment(endDate).format("MM/DD/YYYY");

    if (sameStartAndEnd) {
      return combined;
    } else{
      return `${startDateFormatted} - ${endDateFormatted}`;
    }
  }

  onPaginationChange(newPage) {
    let {
      props: {
        jobStore,
        viewStore: {
          unassignedJobSearch
        }
      }
    } = this;
    this.props.viewStore.unassignedJobSearch = {
      ...unassignedJobSearch,
      page: newPage
    }

    jobStore.loadUnassignedJobs()
  }

  render() {
    let {
      props: {
        jobStore: {
          unassignedJobs: {
            objects,
            isLoading,
            meta
          }
        },
        viewStore: {
          unassignedJobSearch: {
            where
          }
        }
      }
    } = this;

    let startDate = moment.unix(parseInt(where.start_date.gte)).toDate();
    let endDate = moment.unix(parseInt(where.end_date.lte)).toDate();      
    
    return (
      <div>
        <div className="unassigned-job-sidebar" >
          <div className="usg-panel__header">
            <h2 className="usg-panel__title">Unassigned jobs</h2>
            <p className="usg-panel__hint">Drag a job onto a technician to assign it.</p>
          </div>

          <div className="filter-bar usg-filters">
            <div className="filter-bar__cell">
              <div className="bp3-input-group usg-filters__search">
                <span className="bp3-icon bp3-icon-search"></span>
                <input
                  className="bp3-input"
                  type="search"
                  placeholder="Job title, number or client"
                  aria-label="Search unassigned jobs"
                  onChange={this.onTermChange.bind(this)}
                  defaultValue={where.term}
                  dir="auto" />
              </div>
            </div>
            <div className="filter-bar__cell">
              <Popover
                minimal={true}
                content={
                  <SearchDateRangePicker
                    startDate={startDate}
                    endDate={endDate}
                    onChange={this.onDateRangeChange.bind(this)}
                  />
                }
                position={Position.BOTTOM_LEFT}
                usePortal={true} >
                <Button
                  className="filter-date"
                  icon="calendar"
                  rightIcon="caret-down"
                  text={formatDateRange(startDate, endDate)}
                />
              </Popover>
            </div>
          </div>

          {objects.length !== 0 &&
            <Footer>
              <div className="bp3-navbar-group responsive-pagination bp3-align-left scrollable-pagination">
                <Pagination
                  value={meta.page}
                  total={meta.total_pages}
                  onChange={this.onPaginationChange.bind(this)}
                />
              </div>
            </Footer>
          }

          <div className="aa-job-wraper" id="external-events" ref={this.listRef}>
            {
              isLoading &&
              // <Spinner />,
              <div className="unassg-loading">
                <div className="block">
                  <span className="skeleton-box" style={{ width: '80%' }}></span>
                  <span className="skeleton-box" style={{ width: '90%' }}></span>
                  <span className="skeleton-box" style={{ width: '100%' }}></span>
                  <span className="skeleton-box" style={{ width: '70%' }}></span>
                </div>
                <div className="block">
                  <span className="skeleton-box" style={{ width: '80%' }}></span>
                  <span className="skeleton-box" style={{ width: '90%' }}></span>
                  <span className="skeleton-box" style={{ width: '100%' }}></span>
                  <span className="skeleton-box" style={{ width: '70%' }}></span>
                </div>
                <div className="block">
                  <span className="skeleton-box" style={{ width: '80%' }}></span>
                  <span className="skeleton-box" style={{ width: '90%' }}></span>
                  <span className="skeleton-box" style={{ width: '100%' }}></span>
                  <span className="skeleton-box" style={{ width: '70%' }}></span>
                </div>
              </div>

            }
            {
              !isLoading && objects.length === 0 && <div>
                <div className="caughtup-message">
                  <img src="../calender-1 1.svg" alt="" width="120" />
                  <strong>No unassigned jobs in this range</strong>
                  <span>Try a wider date range or a different search.</span>
                </div>
              </div>
            }
            {
              !isLoading && objects.length > 0 && objects.map((job) => {
                return (
                  <div className="card usg-card fc-events" data-event={JSON.stringify(this.dropData(job))} key={job.id}>                                        
                    <div className="card-body unsg-card" title="Drag and drop infront of technician name to assign job">
                      <div className='card-top'>
                        <div className='event-number'>#{job.attributes.job && job.attributes.job.event_number}</div>
                        <div className='event-tag' style={{ backgroundColor: `#${job.attributes.service_type.color}`, color: '#ffffff' }}>{job.attributes.service_type && job.attributes.service_type.name} {job.attributes && job.attributes.service_agreement && job.attributes.service_agreement.id && <span className='bp3-icon-standard bp3-icon-repeat unassigned-repeat-icon repeat-icon'></span>} </div>
                      </div>
                      <div className='fc-title'>{job.attributes.title}</div>                      
                      <div className='card-row'>
                        <div className="client-name">{job.attributes.client_name}</div>
                        <div className="full-address">{job.attributes.location && job.attributes.location.full_address}</div>
                      </div>  
                      <div className='card-bottom'> 
                        <div className='card-date'>
                          {this.renderDateTime(job.attributes.start_date, job.attributes.end_date)}
                        </div>
                      </div>                
                    </div>
                  </div>
                )
              })
            }
          </div>

        </div>

      </div>


    )
  }
}

export default UnassignedJob;